import videojs from 'video.js';
import LoopSource from '@Components/LoopSource/component.js';

// Get the Component base class from Video.js
const Button = videojs.getComponent('Button');

// The videojs.extend function is used to assist with inheritance. In
// an ES6 environment, `class TitleBar extends Component` would work
// identically.
var LoopSourceButton = videojs.extend(Button, {

  // The constructor of a component receives two arguments: the
  // player it will be associated with and an object of options.
  constructor: function(player, options) {

    // It is important to invoke the superclass before anything else, 
    // to get all the features of components out of the box!
    Button.call(this, player, options);

    this.addClass('vjs-button-loop-source');
    this.addClass('vjs-icon-circle');

    this.player().ready(() => {
      
    });
  },

  handleClick(event) {
    // Remove class from SeekBar
    let controlBar = this.player().getChild('DNSBar');
    let loopSource = controlBar.getChild('LoopSource');
    let seekBar = loopSource.getChild('SeekBar');
    if (LoopSource.loopMode === true) {
      seekBar.removeClass('loop-source-mode-on');
      this.removeClass('vjs-loop-source-enabled');
      LoopSource.loopMode = false;
      LoopSource.canMoveStart = true;
      LoopSource.canMoveEnd = false;
      clearInterval(loopSource._loopTimeOut);
      this.controlText('Activar Loop');
    }else{
      // Add class to SeekBar
      seekBar.addClass('loop-source-mode-on');
      this.addClass('vjs-loop-source-enabled');
      LoopSource.loopMode = true;
      LoopSource.canMoveStart = true;
      LoopSource.canMoveEnd = false;
      this.controlText('Desactivar Loop');
    }
  },

});

LoopSourceButton.prototype.controlText_ = 'Activar Loop';

// Register the component with Video.js, so it can be used in players.
videojs.registerComponent('LoopSourceButton', LoopSourceButton);

export default LoopSourceButton;
